import { doc, getDoc, serverTimestamp, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

export async function generateFleetSignupCode(orgCode: string, generatedBy: string): Promise<{
  code: string;
  expiresAt: number;
}> {
  const code = String(Math.floor(1000 + Math.random() * 9000));
  const now = Date.now();
  const expiresAt = now + 15 * 60 * 1000;
  await setDoc(doc(db, 'fleet_signup_codes', orgCode), {
    code,
    orgCode,
    generatedBy,
    expiresAt: Timestamp.fromMillis(expiresAt),
    createdAt: serverTimestamp(),
  });
  return { code, expiresAt };
}

/** Returns the existing valid code unless expired or [forceRegenerate] is true. */
export async function getOrCreateFleetSignupCode(
  orgCode: string,
  generatedBy: string,
  forceRegenerate = false
): Promise<{ code: string; expiresAt: number }> {
  if (!forceRegenerate) {
    const snap = await getDoc(doc(db, 'fleet_signup_codes', orgCode));
    if (snap.exists()) {
      const data = snap.data();
      const expiresAt = (data.expiresAt as Timestamp | undefined)?.toMillis?.() ?? 0;
      const code = String(data.code ?? '');
      if (code && expiresAt > Date.now()) {
        return { code, expiresAt };
      }
    }
  }
  return generateFleetSignupCode(orgCode, generatedBy);
}
